<template>
    <div class="field is-horizontal">
        <div class="field-label is-normal">
            <label class="label">Deposit Rate</label>
        </div>
        <div class="field-body">
            <div class="field">
                <div class="control has-icons-left">
                    <div class="select is-fullwidth" v-model="deposit_rate" :class="{ 'is-danger': errors.deposit_rate }">
                        <select v-model="deposit_rate">
                            <option value="" selected disabled>Select Currency</option>
                            <option value="1">JPY</option>
                            <option value="2">USD</option>
                        </select>
                    </div>
                    <span class="icon is-left">
                        <i class="fas fa-users"></i>
                    </span>
                    <p v-if="errors.deposit_rate" class="help is-danger">{{ errors.deposit_rate[0] }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {

            }
        },
        computed: {
            deposit_rate: {
                get() {
                    return this.$store.getters.getNewPricePlan.deposit_rate
                },
                set(value) {
                    this.$store.dispatch('setNewPricePlanFieldValue', {field: 'deposit_rate', value: value})
                }
            },
            errors() {
                return this.$store.getters.getNewPricePlanErrors
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/PricePlans/NewPlan/Inputs/DepositRateSelect.vue